export default __webpack_public_path__ + "static/media/flag-cape-verde.a3fce67e.svg";